import gql from "graphql-tag";

export default gql`
  mutation CreateUser($userInput: UserInputInput, $customerId: ID) {
    createUser(userInput: $userInput, customerId: $customerId) {
      id
      username
    }
  }
`;
